/** Short labels for policy and budget refusal codes (badges, chips). */
export const REFUSAL_LABELS: Record<string, string> = {
  PERMISSION_INACTIVE: 'Permission inactive',
  PERMISSION_EXPIRED: 'Permission expired',
  ASSET_NOT_ALLOWED: 'Asset not allowed',
  VENUE_NOT_ALLOWED: 'Venue not allowed',
  SLIPPAGE_EXCEEDED: 'Slippage too high',
  PRICE_IMPACT_EXCEEDED: 'Price impact too high',
  LIQUIDITY_TOO_LOW: 'Liquidity too low',
  QUOTE_STALE: 'Quote stale',
  QUOTE_MISSING: 'No quote',
  PROPOSAL_EXPIRED: 'Proposal expired',
  DUPLICATE_PROPOSAL: 'Duplicate',
  ACCOUNT_FROZEN: 'Account paused',
  BUDGET_EXHAUSTED: 'Budget exhausted',
  QUOTE_TOO_OLD: 'Quote too old',
  // arbitrage App API (signing-time enforcement of the customer's permission)
  CAPABILITY_MISSING: 'Not permitted',
  VENUE_DENIED: 'Venue not permitted',
  TOKEN_DENIED: 'Token not permitted',
  RECIPIENT_DENIED: 'Recipient not permitted',
  PER_ORDER_CAP: 'Over per-order cap',
  WINDOW_CAP: 'Over window cap',
  EXPOSURE_CAP: 'Over exposure cap',
  INSUFFICIENT_BALANCE: 'Insufficient balance',
  MIN_OUT_UNREACHABLE: 'Price moved',
  TOKEN_RISK: 'Token risk',
  UNARMED: 'Dry run (unarmed)',
  DRY_RUN_ONLY: 'Dry run only',
}

export function refusalLabel(code: string): string {
  return REFUSAL_LABELS[code] ?? code.toLowerCase().replace(/_/g, ' ')
}
